<template>
  <div class="visitor-detail">
    <el-tabs v-model="activeName">
      <el-tab-pane label="产品明细" name="1">
        <productDetail />
      </el-tab-pane>
      <el-tab-pane label="订单访客" name="2">
        <orderVisitor />
      </el-tab-pane>
    </el-tabs>
    <div class="back" @click="$router.back()">返回</div>
  </div>
</template>

<script>
//当前实例组件
import productDetail from "./components/productDetail.vue";
// import orderDetail from "./components/orderDetail.vue";
import orderVisitor from "./components/orderVisitor.vue";

export default {
  components: {
    productDetail,
    orderVisitor,
  },
  data: () => ({
    activeName: ""
  }),

  created() {
    this.activeName = this.$route.query.type;
  },

  methods: {},
};
</script>

<style lang="scss" scoped>
.visitor-detail{
  background: #ffffff;
  position: relative;
  /deep/.el-tabs__nav{
    margin-left: 30px;
    .el-tabs__item{
      height: 60px;
      line-height: 60px;
    }
  }
  .back{
    position: absolute;
    top: 14px;
    right: 30px;
    width: 80px;
    height: 32px;
    background: rgb(244,121,0);
    border-radius: 4px;
    line-height: 32px;
    text-align: center;
    font-size: 14px;
    color: #FFFFFF;
    cursor: pointer;
  }
}
</style>